import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import httpClient from 'utils/httpClient';
import { RETRIEVE_SESSION_URL } from './retrieveSessionContent';

const DELETE_HOMEWORK_FILE = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-attachment-home-work`;
const DELETE_HOMEWORK_VIDEO = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/unit/${id}/teacher-unit-video`;

export type DeleteHomeworkFileBody = {
  id: number;
  courseId: number;
  indices: number[];
  isUnit: boolean;
};

export type DeleteHomeworkFileResponse = {
  _data: {
    homeWork: {
      // eslint-disable-next-line camelcase
      section_id: number;
    };
  };
};

export const deleteHomeworkFile = ({
  id,
  courseId,
  indices,
  isUnit,
}: DeleteHomeworkFileBody) => {
  let params = {};
  if (isUnit) {
    params = { indices, 'is-unit': isUnit };
  } else {
    params = { indices };
  }
  return httpClient.delete<DeleteHomeworkFileResponse>(
    DELETE_HOMEWORK_FILE(id, courseId),
    {
      params,
    },
  );
};

export const useDeleteHomeworkFile = (
  opts?: UseMutationOptions<
    AxiosResponse<DeleteHomeworkFileResponse>,
    AxiosError<any>,
    DeleteHomeworkFileBody
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<DeleteHomeworkFileResponse>,
    AxiosError<any>,
    DeleteHomeworkFileBody
  >(deleteHomeworkFile, {
    ...opts,
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(RETRIEVE_SESSION_URL(id));
    },
  });
};
export const deleteHomeworkVideo = ({
  id,
  courseId,
  indices,
  isUnit,
}: DeleteHomeworkFileBody) => {
  let params = {};
  if (isUnit) {
    params = { indices, 'is-unit': isUnit };
  } else {
    params = { indices };
  }
  return httpClient.delete<DeleteHomeworkFileResponse>(
    DELETE_HOMEWORK_VIDEO(id, courseId),
    {
      params,
    },
  );
};

export const useDeleteHomeworkVideo = (
  opts?: UseMutationOptions<
    AxiosResponse<DeleteHomeworkFileResponse>,
    AxiosError<any>,
    DeleteHomeworkFileBody
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<DeleteHomeworkFileResponse>,
    AxiosError<any>,
    DeleteHomeworkFileBody
  >(deleteHomeworkVideo, {
    ...opts,
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(RETRIEVE_SESSION_URL(id));
    },
  });
};
